import { __spreadArray } from 'tslib';
import { TEMPLATES } from '../consts.js';
import { createCaretPosPlugin } from './plugins.js';
import { createPreventCaretJumpPostprocessor } from './postprocessors.js';
import { createDisallowInputPreprocessor, createValidationPreprocessor } from './preprocessors.js';
import { segmentsToString, getValueSegments, shiftSegmentsData, segmentsToPattern } from './utils.js';
import 'date-fns/isValid';
import 'date-fns/differenceInDays';
import 'date-fns/format';
import 'date-fns/isSameDay';
import 'date-fns/parse';
import 'date-fns/clamp';
import 'date-fns/getDaysInMonth';
import '../utils/index.js';

function createMaskOptions(view, min, max, autoCorrection, onCorrection) {
    var template = TEMPLATES[view];
    var stringTemplate = segmentsToString(template.segments, template.separators);
    return {
        mask: createMaskExpression(template),
        preprocessors: __spreadArray([
            createDisallowInputPreprocessor()
        ], (autoCorrection
            ? [createValidationPreprocessor(template, stringTemplate, min, max, onCorrection)]
            : []), true),
        postprocessors: [createPreventCaretJumpPostprocessor()],
        plugins: [createCaretPosPlugin(template)],
    };
}
function createMaskExpression(_a) {
    var templateSegments = _a.segments, separators = _a.separators;
    return function (_a) {
        var value = _a.value;
        if (value.length < 2)
            return [/\d/];
        var rawSegments = getValueSegments(value, separators);
        var segments = shiftSegmentsData(rawSegments, templateSegments);
        return segmentsToPattern(segments, separators);
    };
}

export { createMaskOptions };
